import { render, staticRenderFns } from "./totalByBranch.vue?vue&type=template&id=2b783230&scoped=true"
import script from "./totalByBranch.vue?vue&type=script&lang=js"
export * from "./totalByBranch.vue?vue&type=script&lang=js"
import style0 from "./totalByBranch.vue?vue&type=style&index=0&id=2b783230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b783230",
  null
  
)

export default component.exports